<!--
 * @Author: Zeng Zhi
 * @LastEditTime: 2023-11-14 11:49:06
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="w-full h-full">
    <el-table :data="tableData" class="text-14px w-full" height="100%" v-loading="tableLoading">
      <el-table-column
        prop="subject"
        show-overflow-tooltip
        label="主题"
        width="200"
      ></el-table-column>
      <el-table-column prop="flowStatus" show-overflow-tooltip label="状态">
        <!-- <template slot-scope="{ row }">
          <div v-if="row.status === 1" class="successTextColor text-hex-81B337">已完成</div>
          <div v-if="row.status === 2" class="infoText text-hex-81B337">审批中</div>
          <div v-if="row.status === 3" class="infoText text-hex-81B337">验收中</div>
          <div v-if="row.status === 0" class="infoText text-hex-81B337">整改中</div>
        </template> -->
      </el-table-column>
      <el-table-column label="操作" width="50">
        <template #default="{row}">
          <div @click.stop="viewDetail(row)" class="cursor-pointer !text-hex-4095e5">查看</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { instance as cloudRender } from 'wiz-cloud-render'
import { SafetyQualityApi } from '@wiz-api/haiguang'

const safetyQualityApi = new SafetyQualityApi()
export default {
  name: 'cockpit-qualitylist',
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tableData: [],
      tableLoading: false, // 列表loading
      currentKKSCode: '', // 当前模型闪烁kkscode
    }
  },
  methods: {
    async viewDetail(row) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'QualityInfo',
            origin: 'tag',
            name: '质量问题详情',
          },
          type: 'tags',
          props: {
            problemId: row.problemId,
          },
        },
      })
      window.dispatchEvent(openEvent)

      if (this.currentKKSCode) {
        await this.toggleModelLight(this.currentKKSCode, false)
      }
      this.currentKKSCode = row.kksCode
      if (!row.kksCode) return
      this.toggleModelLight(this.currentKKSCode, true)
      await this.setModelBlur(row.kksCode)
    },

    /**
     * @description 开启或关闭模型闪烁
     * @param {String} code 模型code
     * @param {Boolean} isLight 是否开启闪烁
     */
    async toggleModelLight(code, isLight) {
      const codeInfoRes = await cloudRender.NodeProxy.getInfo('Code', code)
      let currentItem = ''
      if (codeInfoRes && codeInfoRes.status) {
        currentItem = codeInfoRes.data
      }
      if (!currentItem) return
      if (isLight) {
        const res = await cloudRender.ModelGlitter.open(
          currentItem,
          ['#ff000080', '#67c23a80'],
          500
        )
        return
      }
      const res = await cloudRender.ModelGlitter.close(currentItem)
    },
    // 设置模型背景虚化
    async setModelBlur(code) {
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        // 恢复模型状态
        await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 128)
      }
      const currentModel = await this.player.Native.ModelTree.findItemByCode(code, 0)
      if (currentModel && currentModel.item) {
        // 设置模型背景虚化
        await this.player.Native.ModelTree.setItemAlpha(currentModel.item, 255)
      }
      // 切换视角
      await this.player.Native.Camera.moveToCode(code, 2)
    },

    /**
     * @description 获取安全质量可视化问题列表
     */
    async getTableList() {
      const currentUser = localStorage.getItem('CurrentUser')
      if (!currentUser) return
      const projectId = JSON.parse(currentUser)?.TenantId
      this.tableLoading = true
      const [err, res] = await safetyQualityApi.getSafetyQualityVisualProblemList({
        body: {
          projectId,
          skipCount: 0,
        },
      })
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
      }
    },
  },
  created() {
    this.getTableList()
  },
  async beforeDestroy() {
    if (this.currentKKSCode) {
      this.toggleModelLight(this.currentKKSCode, false)
    }
    // 获取根节点
    const rootInfo = await this.player.Native.ModelTree.getRootItems()
    if (rootInfo?.length && rootInfo[0].item) {
      // 恢复模型状态
      await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 255)
    }
  },
}
</script>

<style lang="scss" scoped></style>
